import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import cx from 'classnames';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SkillEvaluationForm.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var messages = defineMessages({
  title: {
    id: "SkillEvaluationModal.title",
    defaultMessage: [{
      "type": 0,
      "value": "Estimate your skill level on course topic"
    }]
  },
  awfulLabel: {
    id: "SkillEvaluationModal.awfulLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Awful"
    }]
  },
  poorLabel: {
    id: "SkillEvaluationModal.poorLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Poor"
    }]
  },
  averageLabel: {
    id: "SkillEvaluationModal.averageLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Average"
    }]
  },
  goodLabel: {
    id: "SkillEvaluationModal.goodLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Good"
    }]
  },
  excellentLabel: {
    id: "SkillEvaluationModal.excellentLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Excellent"
    }]
  }
});
var SkillEvaluationForm = function SkillEvaluationForm(_ref) {
  var formatMessage = _ref.intl.formatMessage,
    skillLevel = _ref.skillLevel,
    setSkillLevel = _ref.setSkillLevel,
    _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? {} : _ref$classes;
  var marks = [{
    value: 1,
    label: formatMessage(messages.awfulLabel)
  }, {
    value: 2,
    label: formatMessage(messages.poorLabel)
  }, {
    value: 3,
    label: formatMessage(messages.averageLabel)
  }, {
    value: 4,
    label: formatMessage(messages.goodLabel)
  }, {
    value: 5,
    label: formatMessage(messages.excellentLabel)
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Typography, {
    className: cx(s.title, classes.title),
    variant: "h6"
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.title)), /*#__PURE__*/_jsx("div", {
    className: cx(s.contentWrapper, classes.skillEvaluationContentWrapper)
  }, void 0, /*#__PURE__*/_jsx(Slider, {
    min: 1,
    max: 5,
    value: skillLevel,
    marks: marks,
    classes: {
      markLabel: cx(s.sliderMarkLabel, classes.sliderMarkLabel),
      root: cx(classes.sliderRoot),
      mark: cx(classes.mark)
    },
    onChange: function onChange(e, value) {
      setSkillLevel(value);
    }
  })));
};
export default injectIntl(withStyles(s)(SkillEvaluationForm));